import type { CookieSetOptions } from 'universal-cookie';

export const COOKIE_SET_OPTIONS: CookieSetOptions = {
  maxAge: 31536000,
  secure: true,
  path: '/',
  sameSite: 'strict',
};
